module.exports = __webpack_public_path__ + "static/littleWomen4-b98ac7f4a4e017c085b58107d4f21a95.jpg";